<template>
  <div :class="{ 'mobile-bg': isMobile }">
    <SEOHead :title="seoData.title" :description="seoData.description" :keywords="seoData.keywords"
      :structured-data="seoData.structuredData" />
    <ProductIntroPC v-if="!isMobile" />
    <ProductIntroMobile v-else />
  </div>
</template>

<script>
import ProductIntroPC from './ProductIntroPC.vue'
import ProductIntroMobile from './ProductIntroMobile.vue'
import SEOHead from '@/components/SEOHead.vue'
import responsive from '@/utils/responsive'

export default {
  components: { ProductIntroPC, ProductIntroMobile, SEOHead },
  data() {
    return {
      responsive,
      seoData: {
        title: '七鼠智服 - AI智能客服系统产品介绍 | 智寰科技',
        description: '七鼠智服是智寰科技基于千亿大模型开发的AI智能客服系统，支持图像识别、语音解析、商品链接处理，为电商企业提供7*24小时智能客服服务，提升客户满意度。',
        keywords: '七鼠智服,AI智能客服系统,电商客服,智能客服产品,图像识别客服,语音客服,智寰科技产品,AI客服机器人',
        structuredData: {
          "@context": "https://schema.org",
          "@type": "Product",
          "name": "七鼠智服",
          "description": "基于千亿大模型的AI智能客服系统，为电商企业提供智能客服解决方案",
          "brand": {
            "@type": "Brand",
            "name": "智寰科技"
          },
          "manufacturer": {
            "@type": "Organization",
            "name": "智寰科技"
          },
          "category": "智能客服软件",
          "offers": {
            "@type": "Offer",
            "description": "让电商服务拥有「智慧温度」，为电商企业实现人力解放、体验升级与增长加速"
          },
          "hasFeature": [
            {
              "@type": "PropertyValue",
              "name": "图像识别与多媒体回复",
              "description": "用户可发送商品图片、截图等，智能客服精准识别内容，并主动回复图片、视频教程或商品示意图"
            },
            {
              "@type": "PropertyValue",
              "name": "语音消息实时解析",
              "description": "用户发送语音消息时，系统自动转写为文字并理解意图，支持方言识别"
            },
            {
              "@type": "PropertyValue",
              "name": "商品链接智能处理",
              "description": "用户发送商品链接后，客服自动解析商品信息，并主动推荐关联商品链接或优惠活动"
            }
          ]
        }
      }
    }
  },
  computed: {
    isMobile() {
      return this.responsive.isMobile
    }
  }
}
</script>

<style scoped>
.page-content {
  text-align: center;
}

/* 移动端背景色 */
.mobile-bg {
  background-color: #F5F7FB;
}
</style>